import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />, 'Send');
